/**
 * Open Cashier Modal Component - Using StandardModal
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../components/ui/modal';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { PlayCircle } from 'lucide-react';

export function OpenCashierModal({ open, onOpenChange, cashier, onConfirm, loading }) {
  const { t } = useTranslation();
  const [amount, setAmount] = useState('');

  const handleConfirm = () => {
    onConfirm({ initial_amount: parseFloat(amount) || 0 });
    setAmount('');
  };

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={t('cashiers.openCashier')}
      description={`Abrindo: ${cashier?.name}`}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button onClick={handleConfirm} disabled={loading} data-testid="confirm-open-btn">
            <PlayCircle className="h-4 w-4 mr-2" />
            {t('cashiers.openCashier')}
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="openAmount">{t('cashiers.initialAmount')} (Fundo de Troco)</Label>
          <Input
            id="openAmount"
            type="number"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            data-testid="open-amount-input"
          />
        </div>
      </div>
    </Modal>
  );
}

export default OpenCashierModal;
